import { GeoPoint } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import React, { useState } from 'react'

import { Button, Col, FlexboxGrid, Grid, Nav } from 'rsuite'

import DeliveryZonesOnMap from '@components/deliveryZone/DeliveryZonesOnMap'
import DeliveryZoneForm from '@components/deliveryZone/DeliveryZoneForm'
import DeliveryZonesSubMenu from '@components/logistic/DeliveryZonesSubMenu'
import LogisticTopMenu from '@components/logistic/LogisticTopMenu'
import { AddOutline } from 'react-ionicons'


export default function DeliveryZonesOnMapPage () {
  const [ selectedZoneId, setSelectedZoneId ] = useState<GQL_ID | null>()
  const [ editedZone, setEditedZone ] = useState<GeoPoint[]>([])
  const [ isPlanningMode, setIsPlanningMode ] = useState(false)
  const deliveryZoneFormId = 'delivery-zones-map-form'

  const handleSubmitHiddenForm = () => {
    const formElement = document.getElementById(deliveryZoneFormId) as HTMLFormElement | null
    formElement?.requestSubmit()
  }

  const showForm = (!!selectedZoneId || selectedZoneId === null) && !isPlanningMode

  return (
    <div style={{ paddingTop: '-2em', paddingBottom: '-2em', paddingLeft: '-1em', paddingRight: '-1em'}}>
      <FlexboxGrid justify='space-between'>
        <div>
          <h1 className="u-heading">Зоны доставки</h1>
          <LogisticTopMenu />
          <DeliveryZonesSubMenu />
          <Nav>
            <Nav.Item
              icon={<AddOutline />}
              onClick={() => {
                setSelectedZoneId(null)
                setEditedZone([])
              }}
            >
                Добавить зону
            </Nav.Item>
          </Nav>
        </div>
        
        <div>
          { !!selectedZoneId || selectedZoneId === null ? (
            <>
              <Button
                onClick={() => {
                  setIsPlanningMode(!isPlanningMode)
                }}
              >
                { !isPlanningMode ? 'Скрыть форму' : 'Показать форму' } 
              </Button>
              { isPlanningMode && (
                <Button
                  appearance='primary'
                  color='green'
                  className='ml-2'
                  onClick={handleSubmitHiddenForm}
                >
                  Сохранить полигон
                </Button>
              )}
            </>
          ) : (
            <div></div>
          )}
          { showForm && (
            <Button 
              appearance='ghost'
              onClick={() => {
                setSelectedZoneId(undefined)
              }}
            >
              Закрыть форму
            </Button>
          )}
        </div>
      </FlexboxGrid>
      <Grid fluid>
        <Col xs={24} md={showForm ? 12 : 24}>
          <DeliveryZonesOnMap 
            selectedZoneId={selectedZoneId}
            onZoneSelect={setSelectedZoneId}
            editedZone={editedZone}
            onZoneChanged={setEditedZone}
          />
        </Col>
        <Col xs={24} md={12} className='px-5' style={{ display: showForm ? 'block' : 'none' }}>
          { (!!selectedZoneId || selectedZoneId === null) && (
            <DeliveryZoneForm 
              zoneId={selectedZoneId}
              newZone={editedZone}
              formId={deliveryZoneFormId}
            />
          )}
        </Col>
      </Grid>
      
    </div>
  )
}